import React from 'react';

type PayArtProps = {
  className?: string;
};

/** Illustrated cash icon — reference POS tile style */
export const CashPayIcon: React.FC<PayArtProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 88 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <ellipse cx="28" cy="58" rx="14" ry="6" fill="#86efac" opacity="0.45" />
    <ellipse cx="60" cy="58" rx="14" ry="6" fill="#86efac" opacity="0.45" />
    <path
      d="M18 44c6-10 18-14 26-10 8 4 20 0 26-10"
      stroke="#f59e0b"
      strokeWidth="3.5"
      strokeLinecap="round"
    />
    <path
      d="M14 48c8-6 16-8 24-6M50 42c8-2 16 0 24 6"
      stroke="#fbbf24"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <rect x="22" y="18" width="44" height="28" rx="4" fill="#22c55e" />
    <rect x="26" y="22" width="36" height="20" rx="2" fill="#4ade80" />
    <circle cx="44" cy="32" r="7" fill="#16a34a" />
    <circle cx="44" cy="32" r="4" fill="#bbf7d0" />
    <path d="M30 14l4 8M54 14l-4 8" stroke="#f59e0b" strokeWidth="2.5" strokeLinecap="round" />
  </svg>
);

/** Manual card / terminal icon — blue card reader style */
export const ManualCardPayIcon: React.FC<PayArtProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 88 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <rect x="14" y="16" width="60" height="40" rx="8" fill="#1d4ed8" />
    <rect x="18" y="20" width="52" height="32" rx="5" fill="#2563eb" />
    <rect x="22" y="26" width="18" height="12" rx="2" fill="#facc15" />
    <rect x="44" y="28" width="22" height="3" rx="1.5" fill="#93c5fd" />
    <rect x="44" y="35" width="16" height="3" rx="1.5" fill="#60a5fa" />
    <rect x="22" y="42" width="44" height="6" rx="3" fill="#1e40af" />
    <text
      x="44"
      y="46"
      textAnchor="middle"
      fill="#ffffff"
      fontSize="7"
      fontWeight="700"
      fontFamily="system-ui, sans-serif"
    >
      CARD
    </text>
    <path d="M34 58h20" stroke="#64748b" strokeWidth="2.5" strokeLinecap="round" />
    <rect x="30" y="58" width="28" height="4" rx="2" fill="#cbd5e1" />
  </svg>
);

/** Mobile app payment icon */
export const MobilePayIcon: React.FC<PayArtProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 88 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <rect x="28" y="8" width="32" height="56" rx="6" fill="#7c3aed" />
    <rect x="31" y="12" width="26" height="46" rx="4" fill="#ede9fe" />
    <rect x="38" y="10" width="12" height="3" rx="1.5" fill="#5b21b6" />
    <rect x="34" y="18" width="20" height="14" rx="3" fill="#8b5cf6" />
    <circle cx="44" cy="25" r="4" fill="#ddd6fe" />
    <path
      d="M42 25h4M44 23v4"
      stroke="#6d28d9"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <rect x="34" y="36" width="20" height="8" rx="4" fill="#22c55e" />
    <path
      d="M40 40h8"
      stroke="#ffffff"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M42 40l2 2 4-4"
      stroke="#ffffff"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="44" cy="52" r="2" fill="#a78bfa" />
    <path
      d="M18 30c3-6 8-9 14-9M56 21c6 0 11 3 14 9"
      stroke="#a855f7"
      strokeWidth="2"
      strokeLinecap="round"
      opacity="0.8"
    />
    <path
      d="M22 38c2-4 5-6 9-7M57 30c4 1 7 3 9 7"
      stroke="#c4b5fd"
      strokeWidth="2"
      strokeLinecap="round"
      opacity="0.8"
    />
  </svg>
);
